import { render, staticRenderFns } from "./Receive.vue?vue&type=template&id=dbf03e64&scoped=true"
import script from "./Receive.vue?vue&type=script&lang=ts"
export * from "./Receive.vue?vue&type=script&lang=ts"
import style0 from "./Receive.vue?vue&type=style&index=0&id=dbf03e64&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbf03e64",
  null
  
)

export default component.exports